import { DomainProductTypeEnum, RecommendationFeature, RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { Box, Heading, SkeletonRectangle } from '@wix/design-system';
import { DomainSearchSuiteModule, SearchRecommendationLayout } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import React from 'react';
import { useIsMobile } from '@wix/core-domain-search';
import { useMatchingLabels } from '../../hooks/useMatchingLabels';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from '../common.scss';
import { Base44Label } from '../Base44Label';
import lazyLabelStyles from '../LazyRecommedationLabel/LazyRecommendationLabel.scss';
import { PreSuggestionLayout } from '../PreSuggestions/PreSuggestions';
export const Base44PreSuggestions = _ref => {
  var _data$recommendations2;
  let {
    query = 'mystunningwebsite'
  } = _ref;
  const {
    data,
    isLoading,
    error
  } = DomainsApiClient.hooks.useListRecommendations({
    query,
    features: [RecommendationFeature.PRICING],
    paging: {
      limit: 3
    },
    productType: {
      domainProductType: DomainProductTypeEnum.BASE44
    }
  }, true, {
    cacheTime: Infinity,
    staleTime: Infinity,
    useErrorBoundary: false
  });
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const {
    resolveActionForSuggestion
  } = DomainSearchSuiteModule.SDK.useSuggestionActionResolver();
  const {
    data: purchasePermissions
  } = DomainsApiClient.hooks.useGetPurchasePermissions({});
  const {
    labels: matchLabels,
    isLoading: isLoadingLabels
  } = useMatchingLabels((data == null ? void 0 : data.recommendations) ?? []);
  const handleGetItClick = async recommendation => {
    var _data$recommendations;
    const position = data == null || (_data$recommendations = data.recommendations) == null ? void 0 : _data$recommendations.findIndex(_ref2 => {
      let {
        id
      } = _ref2;
      return id === recommendation.id;
    });
    DomainSearchSuiteModule.internals.bi.onGetItClick == null || DomainSearchSuiteModule.internals.bi.onGetItClick({
      domain: recommendation.domain || '',
      type: recommendation.label,
      position
    });
    if (recommendation.domain) {
      await resolveActionForSuggestion(recommendation.domain);
    }
  };
  const notShowPreSuggestions = error || !isLoading && !(data != null && (_data$recommendations2 = data.recommendations) != null && _data$recommendations2.length);
  if (notShowPreSuggestions) {
    return null;
  }
  const LabelContainer = _ref3 => {
    var _matchLabels$find;
    let {
      premium,
      visible,
      children,
      domain,
      label: existingLabel
    } = _ref3;
    const matchingLabel = (!existingLabel || existingLabel === RecommendationLabel.UNKNOWN_LABEL) && (matchLabels == null || (_matchLabels$find = matchLabels.find(label => label.domain === domain)) == null ? void 0 : _matchLabels$find.label);
    if (!visible && !isLoadingLabels && !matchingLabel) {
      return null;
    }
    return /*#__PURE__*/React.createElement(SearchRecommendationLayout.LabelContainer, {
      premium: premium,
      visible: true,
      domain: domain
    }, !visible && isLoadingLabels ? /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: lazyLabelStyles.skeleton,
      width: "82px",
      height: "20px"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, matchingLabel && /*#__PURE__*/React.createElement(Base44Label, {
      primary: false,
      label: matchingLabel,
      domain: domain
    }), children));
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: isMobile ? 'SP4' : 'SP7',
    width: "100%",
    align: "center",
    padding: isMobile ? '0' : 'SP4 0 SP10 0'
  }, /*#__PURE__*/React.createElement(Box, {
    padding: isMobile ? 'SP4 0 10px 0' : '0'
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.sectionTitle
  }, t('domains_search_gate.base44.gate.recommended.title'))), /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.SearchRecommendationList, {
    items: (data == null ? void 0 : data.recommendations) ?? [],
    isLoading: isLoading,
    Layouts: {
      ...PreSuggestionLayout,
      Label: Base44Label,
      LabelContainer
    },
    disabled: !(purchasePermissions != null && purchasePermissions.hasPermission),
    onClickGetIt: handleGetItClick,
    firstSuggestionPrimary: false
  }));
};
//# sourceMappingURL=Base44PreSuggestions.js.map